const SDK_VERSION = "10.56.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
